import React from 'react';
import { Checkbox as AntCheckbox } from 'antd';
import type { CheckboxProps } from 'antd';
import clsx from 'clsx';

/**
 * Thin wrapper over the Antd Checkbox (per the antd wrapper standardization plan):
 * single import source through @common/components and a `wk-checkbox` class hook.
 */
export const Checkbox = ({ className, ...props }: CheckboxProps) => (
  <AntCheckbox {...props} className={clsx('wk-checkbox', className)} />
);

Checkbox.Group = AntCheckbox.Group;
